import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { WidgetText } from "../Widgets/WidgetText";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";

export class PopupTextComponentProps {
    widget: WidgetText;
}

export class PopupTextComponent extends JSXComponent {
    props: PopupTextComponentProps;
    title: LanguageStringComponent;
    editor: HTMLElement;
   

    constructor(props: PopupTextComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetText}>
            {this.renderTitle()}
            <div>
                {this.renderEditor()}
            </div>
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        }); 
        return this.title.render();
    }

    renderEditor(): HTMLElement {
        let editorElement: HTMLElement = <div id="summernote" >
            <div class="html-editor"></div>
        </div>;

        let lang = app.language + "-" + app.languageUpperCase;
        let htmlEditorJQuery = this.getSummernoteJQuery(editorElement);
        (htmlEditorJQuery as any).summernote({
            lang: lang,
            placeholder: Resources.Common.emailContent,
            height: 300,
            maxHeight: 300,
            focus: true,
            codemirror: {
                theme: 'monokai'
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture']],
                ['view', ['fullscreen', 'codeview', 'help']]
            ]
        });
        (htmlEditorJQuery as any).summernote('code', `${this.props.widget.props.content}`);

        htmlEditorJQuery.on("summernote.blur", (e) => {
            this.props.widget.props.content = (htmlEditorJQuery as any).summernote('code');
        });

        return editorElement;
    }

    getSummernoteJQuery(editorElement: HTMLElement): JQuery<Element> {
        return $(editorElement.querySelector(".html-editor"));
    }

    render(): HTMLElement {
        return this.element;
    }
}
